<div class="input-container">
  <label class="input-label">{{ label }}</label>

  <mat-form-field [class]="inputStyle" appearance="outline">
    <mat-select
      [formControl]="selectFormControl"
      [placeholder]="placeholder"
      (openedChange)="$event ? onPanelOpen() : onPanelClose()"
      [multiple]="multiple"
      [compareWith]="compareValues"
    >
      <div class="select-container">
        <mat-form-field [class]="inputStyle" appearance="outline">
          <input
            #search
            autocomplete="off"
            placeholder="Search"
            aria-label="Search"
            matInput
            [formControl]="searchTextboxControl"
          />

          <button *ngIf="search.value" matSuffix mat-icon-button aria-label="Clear" (click)="clearSearch($event)">
            <mat-icon>close</mat-icon>
          </button>
        </mat-form-field>

        <mat-optgroup *ngIf="(filteredOptions | async)?.length === 0">
          <div class="no-results">No results found</div>
        </mat-optgroup>

        <mat-option
          class="multi-select-options"
          *ngFor="let option of filteredOptions | async"
          [value]="option"
          [disabled]="isDisabled(option)"
        >
          {{ option }}
        </mat-option>
      </div>
    </mat-select>
  </mat-form-field>
</div>
